export enum EmailFormNames {
  Subject = 'subject',
  Recipient = 'recipient',
  Cc = 'cc',
  Body = 'body',
}
